import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import firebase from '../Firebase';
import { Link } from 'react-router-dom';

class Create extends Component {

  constructor() {
    super();
    this.ref = firebase.firestore().collection('tutorials');
    this.state = {
      tutor:'',
      learner:'',
      subject:'',
      content:'',
      school:'',
      rating:0
    };
  }
  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  onSubmit = (e) => {
    e.preventDefault();

    const { tutor, learner, subject,content, school,rating, id  } = this.state;
    this.ref.add({ 
      tutor,
      learner, 
      subject,
      school, 
      content, 
      rating,
    }).then((docRef) => {
      this.setState({
        tutor: 'Nompumelelo',
        learner:'Nelly',
        subject: 'NMaths',
        school:'Somkick' ,
        content: 'Calculus',
        rating: 5
        
      });
      this.props.history.push("/list")
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
  }

  render() {
    const { title, description, author } = this.state;
    return (
      <div>
           <nav class="navbar navbar-dark bg-primary">
             <h3  class="navbar-brand mb-0 h1">Adding a Tutorial Session Record</h3><br></br>
             <button class="btn btn-dark"><Link to="/list">Back to Sessions List</Link></button>
             
            </nav> <br></br>

        <div class="container">
          <div class="panel-heading">
          </div>
        

            <form onSubmit={this.onSubmit}>

                <div class="form-group">
                    <input type="text" required class="form-control" name="tutor" value={this.tutor} onChange={this.onChange} placeholder="Tutor" />
                </div>

                <div class="form-group">
                    <input type="text" required class="form-control" name="learner" value={this.learner} onChange={this.onChange} placeholder="Learner" />
                </div>

                <div class="form-group">
                    <input type="text" required class="form-control" name="subject" value={this.subject} onChange={this.onChange} placeholder="Subject" />
                </div>

                <div class="form-group">
                <textArea class="form-control" required name="content" onChange={this.onChange} placeholder="Content" cols="80" rows="3">{this.content}</textArea>
 
                </div>

              <div class="form-group">
                <input type="text" class="form-control" required name="school" onChange={this.onChange} value={this.school} placeholder="School" />
              </div>

              <div class="form-group">
              <label for="rating">Rating</label>
                <select class="form-control-select" name="rating" required onChange={this.onChange} value={this.rating} placeholder="Rating">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    </select>
              </div>

              <button type="submit" class="btn btn-success">Submit</button>
            </form><br></br>
          </div>
          <nav class="navbar navbar bg-primary">
          <h6>© copyright My Tutor . All right reserved | 2019</h6>
            </nav>
        
        </div>
         
      
    );
  }
}

export default Create;